<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import type { OwnerType } from "@core/composables"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            ownerType: {
                self: "Mon entreprise",
                client: "Client externe",
            },
        },
    },
})

// ================================
// TYPES & INTERFACES
// ================================
interface Props {
    /**
     * Type de titulaire sélectionné (v-model)
     */
    modelValue: OwnerType
}

interface Emits {
    /**
     * Émis lors du changement de type
     */
    (e: "update:modelValue", value: OwnerType): void
}

// ================================
// PROPS & EMITS
// ================================
defineProps<Props>()
const emit = defineEmits<Emits>()

// ================================
// DONNÉES CALCULÉES
// ================================

/**
 * Options pour le sélecteur de type
 */
const getOptions = computed(() => [
    { label: t("ownerType.self"), value: "self" },
    { label: t("ownerType.client"), value: "client" },
])

// ================================
// INTERACTIONS
// ================================

/**
 * Gère le changement de type de titulaire
 * @param value - Nouveau type sélectionné
 */
function onChangeType(value: OwnerType): void {
    emit("update:modelValue", value)
}
</script>

<template>
    <div class="owner-type-selector flex justify-center">
        <!-- ================================ -->
        <!-- SÉLECTEUR DE TYPE -->
        <!-- ================================ -->
        <BaseSelectButton
            :model-value="modelValue"
            :options="getOptions"
            option-label="label"
            option-value="value"
            :allow-empty="false"
            @update:model-value="onChangeType"
        />
    </div>
</template>
